<template>
    <div ref="bagStep4" class="selection-summary row flex flex-col justify-center overflow w-full mt-5 mb-2" :class="bagStep < 4 && 'grayed'">
        <div v-if="bagStep < 4" class="cover-up"></div>
        <div class="w-full md:mb-1 roboto md:flex justify-between">
            <div class="text-wrapper">
                <p class="steps bold m-0">Step {{ totalSteps }} of {{ totalSteps }}</p>
                <h1 class="text-center">{{ webstoreContent.addToBag }}</h1>
                <p class="mb-2 dark-blue-text">{{ webstoreContent.cartPage.summary_description }}</p>
                <div v-if="activeProductInfo.productAlert" class="product-alert">{{ activeProductInfo.productAlert }}</div>
            </div>
            <div class="selection-wrapper max-w-[530px] p-2" :class="messageWrapperClass">
                <h1 class="m-0">Review Items</h1>
                <hr style="margin-bottom: 30px;"/>
                <div class="product-summary">
                    <p class="quantity">Qty: {{ currentQuantity }}</p>
                    <div class="product-info">
                        <p class="text-lg font-medium" style="line-height: 140%;">{{ activeProductInfo.name }}</p>
                        <p class="subtext font-normal" style="line-height: 140%;">{{ activeOffer.offerName }}</p>
                    </div>
                    <h1 class="price m-0">{{ currencySymbol.toUpperCase() }}{{ itemTotal.toFixed(2) }} / {{ activeOffer.defaultPaymentTerm }}</h1>
                </div>
                <div v-if="isSafetyEventReviewActive" class="product-summary">
                    <p class="quantity">Qty: {{ currentQuantity }}</p>
                    <div class="product-info">
                        <p class="text-lg font-medium" style="line-height: 140%;">{{ webstoreContent.cartPage.ser_title }}</p>
                        <p class="subtext font-normal" style="line-height: 140%;">{{ webstoreContent.cartPage.ser_sku }}</p>
                    </div>
                    <h1 class="price m-0">{{ currencySymbol.toUpperCase() }}{{ (safetyEventReviewPrice * currentQuantity).toFixed(2) }} / month</h1>
                </div>
                <div v-if="totalCablesSubmittedCount === cablesNeededCount" >
                    <div
                        v-for="(info, name) in totalCompiledData"
                        :key="name"
                        class="product-summary"
                    >
                        <p class="quantity">Qty: {{ info.qty }}</p>
                        <div class="product-info">
                            <p class="text-lg font-medium" style="line-height: 140%;">{{ name }}</p>
                            <p v-if="info && info.list && info.list.length > 0" class="subtext font-normal -mt-0.5">for 
                                <span
                                    v-for="(value, index) in info.list"
                                    :key="value"
                                >
                                    {{ value }}{{ index !== info.list.length -1 ? ',' : '' }}
                                </span>
                            </p>
                        </div>
                        <h1 class="price m-0 font-bold">Included</h1>
                    </div>
                </div>
                <hr />
                <div class="w-full flex justify-between">
                    <h1 class="m-0">Subtotal</h1>
                    <h1 class="price m-0 final-price">{{ currencySymbol.toUpperCase() }}{{ cartTotal }} / {{ activeOffer.defaultPaymentTerm }}</h1>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import { WebstoreResources } from "../../../mixins/webstore-resources";
    import vButton from '../../utils/button';
    export default {
        mixins: [WebstoreResources],
        components: {vButton},
        props: {
            shift: {
                required: true,
                default: true,
            },
            submitButtonText: {
                type: String,
                required: true
            },
            addToCartDisabled: {
                type: Boolean,
                required: false
            },
            totalSteps: {
                required: true,
                type: String
            } 
        },
        data() {
            return {
                flash: false,
            }
        },
        computed: {
            ...mapGetters("content", ["webstoreContent"]),

            ...mapGetters([
                'activeProductKey',
                'activeOfferKey',
                'activeProductInfo',
                'currencySymbol',
                "productCatalog",
                "bagStep",
            ]),
            ...mapGetters('checkout', ['safetyEventReviewPrice']),

            itemTotal() {
                return this.calculateTotalPrice(this.activeProductInfo.offerings[this.activeOfferKey].salesPrice) * this.currentQuantity
            },

            // Handles adding in SER and other additionals
            cartTotal() {
                return (this.itemTotal + (this.isSafetyEventReviewActive ? (this.safetyEventReviewPrice * this.currentQuantity) : 0)).toFixed(2);
            },

            currentQuantity() {
                return this.$store.getters[`${this.activeProductKey}/quantity`];
            },

            cablesNeededCount() {
                return this.$store.getters[`${this.activeProductKey}${this.activeOfferKey}CableSelection/base/cablesNeededCount`];
            },

            messageWrapperClass() {
                let messageClass = '';
                if (this.totalCablesSubmittedCount === this.cablesNeededCount) {messageClass += 'valid '}
                if (this.flash) {messageClass += 'flash '}
                return messageClass;
            },

            action() {
                if (this.message && this.message.includes('Would you like to try with make model year instead?')) {
                    return { text: 'Input MMY', action: () => this.changeCableSelectionType('mmy') }
                } else if (this.message && this.message.includes('We recommend selecting this cable via plug type.')) {
                    return { text: 'Input Plug Type', action: () => this.changeCableSelectionType('plug type') }
                }
            },

            activeOffer() {
                if (this.activeOfferKey) {
                    return this.activeProductInfo.offerings[this.activeOfferKey]
                } else {
                    return this.activeProductInfo.offerings[
                        this.activeProductInfo.defaultOffering
                    ]
                }
            },

            cableSkuToNames() {
                let cableNames = {};
                let typeOfProductCable = this.activeProductKey.includes("AG")
                    ? "AG-CBL"
                    : "VG-CBL";
                if (
                    "CBL" in this.productCatalog &&
                    typeOfProductCable in this.productCatalog.CBL
                ) {
                    let cablesAvailable = this.productCatalog.CBL[typeOfProductCable]
                    .offerings;
                    for (let cableKey in cablesAvailable) {
                        cableNames[cableKey] = cablesAvailable[cableKey].offerName;
                    }
                }
                return cableNames;
            },
        },
        methods: {
            changeCableSelectionType(type) {
                this.$emit('change-cable-selection-type', type)
            },

            clearTotalCablesSubmittedData() {
                this.$emit('clear')
            },

            scrollToMessage() {
                let messageElement = this.$refs['selectionWrapper'];
            
                if (messageElement) {
                    var top = messageElement.offsetTop - 300;

                    window.scrollTo({
                    left: 0,
                    top,
                    behavior: 'smooth',
                    });
                }
            },

            handleFlash() {
                this.flash = true;
                this.scrollToMessage();
                setTimeout(() => this.flash = false, 1000);
            },

            addToCart() {
                this.$emit("add-to-cart");
            },
        }
    }
</script>

<style scoped>

    @media (min-width: 736px) {
        .overflow {
            margin: 0 auto;
        }
        .shift {
            margin-left: -55px;
        }
    }

    .selection-summary {
        margin-top: 350px;
        margin-bottom: 200px;
    }

    .selection-summary h1 {
        font-size: 30px;
        font-weight: bold;
    }

    .selection-wrapper h1 {
        font-size: 20px !important;
    }

    .selection-wrapper {
        width: 100%;
        height: fit-content;
        background: #F6F7F9;
        opacity: .8;
        border-radius: 8px;
        display: inline-block;
        position: relative;
        border-radius: 10px;
    }

    .message {
        -webkit-transition: color .6s linear; /* Saf3.2+, Chrome */
        -moz-transition: color .6s linear; /* FF3.7+ */
        -o-transition: color .6s linear; /* Opera 10.5 */
        transition: color .6s linear;
    }

    @media (max-width: 736px) {
        .selection-wrapper {
            padding: 30px;
        }
        .button-wrapper {
            margin-top: 30px;
        }
        .text-wrapper h1 {
            text-align: center !important;
        }
    }

    .text-wrapper h1 {
        text-align: left;
    }

    .valid {
        background: #F2F7FF;
        border: 1px solid #F2F7FF;
    }

    .valid h3 {
        color: #00263E !important;
    }

    .selection-wrapper h3 {
        color: #B11121;
        margin: 0;
        font-weight: bold;
        font-size: 20px;
        line-height: 20px;
        text-align: left;
    }

    .selection-wrapper hr {
        border: 1px solid #C1C9D1;
        width: 100%;
        height: 0;
        margin-top: 10px;
        margin-bottom: 20px;
    }
        
    .selection-wrapper p {
        line-height: 20px;
        font-size: 18px;
        text-align: left;
        color: #00263E;
    }

    .qty {
        margin-top: 5px;
    }

    .change-button {
        width: fit-content;
        height: 42px;
        border: 1px solid #B11121;
        border-radius: 20px;
        color: #B11121;
        font-size: 20px;
        padding: 5px 20px;
        line-height: 24px;
        margin-top: 30px;
        font-weight: bold;
    }

    .reset {
        position: absolute;
        top: 31px;
        right: 57px;
        text-decoration: underline;
        cursor: pointer;
        font-size: 20px;
    }

    .underline {
        text-decoration: underline;
        margin-left: 8px;
    }

    .product-info {
        width: 50%;
    }

    .product-summary p {
        margin-top: 0;
        font-size: 16px;
    }

    .steps {
        color: #8390A0;
    }

    .product-summary .subtext {
        font-size: 13px;
    }

    .product-summary h1 {
        margin-top: 0;
        font-size: 16px !important;
    }

    .product-alert {
        margin: 0 auto;
        margin-top: -10px;
        margin-bottom: 40px;
        color: #9F6000;
        font-weight: bold;
        background-color: #FEEFB3;
        padding: 20px;
        width: fit-content;
        border-radius: 5px;
    }


    .product-summary {
        display: flex;
        justify-content: flex-start;
        margin-bottom: 30px;
    }

    .grayed {
        opacity: 0.4;
        overflow: hidden;
    }

    .cover-up {
        height: 100%;
        width: 100%;
        position: absolute;
        z-index: 10;
        left: 0;
    }

    .final-price {
        width: 50% !important;
    }

    .quantity {
        width: 20%;
    }

    .price {
        width: 30%;
        text-align: right;
    }

</style>
